<template>
	<div class="mb-4">
		<Promotions></Promotions>
	</div>
</template>

<script>
import Promotions from '../Widgets/Promotions/PromotionsList/Promotions.vue';
export default {
	name: 'Promociones',
	components: {
		Promotions
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>